import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Layout from "../../components/Layout";

/**
 * `/team/me` thin redirect. If the auth context is still loading we
 * render a skeleton so we don't flash the redirect.
 */
export default function TeamMeRedirect() {
  const { user } = useAuth();

  useEffect(() => {}, [user]);

  if (user === null) {
    return (
      <Layout>
        <div className="h-32 bg-slate-100 rounded animate-pulse" />
      </Layout>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={`/team/${user.id}`} replace />;
}
